import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'regateRang'
})
export class RegateRangPipe implements PipeTransform {

  transform(rang: any): any {
    const rangNumber = parseInt(rang, 10);
    if (rangNumber === 1) {
      return '1er';
    } else if (rangNumber > 1) {
      return `${rangNumber}ème`;
    } else if (rangNumber === 0 || rangNumber == null) {
      return 'NC';
    }
  }

}
